export function toKeys<T>(value: T): Array<keyof T & string> {
  return Object.keys(value) as Array<keyof T & string>;
}
